module.exports = __webpack_public_path__ + "static/media/zoo.9dc843ae.jpg";